"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castiglione-delle-stiviere": {
    "a9392394": [{
      "hkey": "1160aa5c",
      "slug": "castiglione-delle-stiviere",
      "name": "Castiglione delle Stiviere",
      "primary": true,
      "skipSearch": false
    }],
    "albana": [{
      "hkey": "1160aa5c",
      "slug": "castiglione-delle-stiviere",
      "name": "Castiglione delle Stiviere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b75bf510": [{
      "hkey": "1160aa5c",
      "slug": "castiglione-delle-stiviere",
      "name": "Castiglione delle Stiviere",
      "primary": true,
      "skipSearch": false
    }],
    "bertasetti": [{
      "hkey": "1160aa5c",
      "slug": "castiglione-delle-stiviere",
      "name": "Castiglione delle Stiviere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b0b48fc": [{
      "hkey": "1160aa5c",
      "slug": "castiglione-delle-stiviere",
      "name": "Castiglione delle Stiviere",
      "primary": true,
      "skipSearch": false
    }],
    "campidello": [{
      "hkey": "1160aa5c",
      "slug": "castiglione-delle-stiviere",
      "name": "Castiglione delle Stiviere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8929a680": [{
      "hkey": "1160aa5c",
      "slug": "castiglione-delle-stiviere",
      "name": "Castiglione delle Stiviere",
      "primary": true,
      "skipSearch": false
    }],
    "valle-scura": [{
      "hkey": "1160aa5c",
      "slug": "castiglione-delle-stiviere",
      "name": "Castiglione delle Stiviere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;